import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import '../assets/css/Chapter.css';
import { baseurl } from "../utility/helper";
import axios from "axios";



function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button className="slick-prev" onClick={onClick}>
      Previous
    </button>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <button className="slick-next" onClick={onClick}>
      Next
    </button>
  );
}

const Chapter = () => {
  // ── Auth check (replace with your actual auth logic) ──────────────────────────
  const mid = parseInt(sessionStorage.getItem("MemberID")) || null;
  const Member_count = sessionStorage.getItem("members_in_india");
  const isLoggedIn = Boolean(mid);
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
      const fetchAdmins = async () => {
        try {
          const res = await axios.get(`${baseurl}/listadmin`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          });
  
          const all = res.data || [];
  
          // Sort by rank ascending, nulls go last
          const sorted = [...all].sort((a, b) => {
            if (a.rank == null && b.rank == null) return 0;
            if (a.rank == null) return 1;
            if (b.rank == null) return -1;
            return a.rank - b.rank;
          });
  
          setAdmins(sorted);
        } catch (err) {
          console.error("Error fetching admins:", err);
        } finally {
          setLoading(false);
        }
      };
  
      fetchAdmins();
    }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const items = [
  { title: "MI Art and Design", icon: "assets/img/member/sig/paint.svg" },
  { title: "MI Ancient Wisdom and Archaeology", icon: "assets/img/member/sig/pyramid.svg" },
  { title: "MI Math", icon: "assets/img/member/sig/calc.svg" },
  { title: "MI Chess", icon: "assets/img/member/sig/chess.svg" },
  { title: "MI Nature + LENSA", icon: "assets/img/member/sig/nature-lensa.svg" },
  { title: "MI Astronomy", icon: "assets/img/member/sig/universe.svg" },
  { title: "MI ATMAA", icon: "assets/img/member/sig/guitar.svg" },
  { title: "MI Invest", icon: "assets/img/member/sig/invest-money.svg" },
  { title: "MI Book", icon: "assets/img/member/sig/book.svg" },
  { title: "MI Mensafirs (Travel)", icon: "assets/img/member/sig/travel.svg" },
  { title: "MI Young Mensan (10-18 years)", icon: "assets/img/member/sig/boy.svg" },
  { title: "MI Puzzle", icon: "assets/img/member/sig/puzzle.svg" },
  { title: "MI Writing and Meanderings", icon: "assets/img/member/sig/writer.svg" },
  { title: "MI Parenting", icon: "assets/img/member/sig/parenting.svg" },
  ];

  const regional = [
  { title: "Food", icon: "assets/img/member/sig/food-dinner.svg" },
  { title: "Board Games", icon: "assets/img/member/sig/board-game.svg" },
  { title: "Politics and Religion", icon: "assets/img/member/sig/politics.svg" },
  { title: "Local Language", icon: "assets/img/member/sig/food-dinner.svg" },
  { title: "Sci-Fi and Fantasy", icon: "assets/img/member/sig/board-game.svg" },
  { title: "Social Impact", icon: "assets/img/member/sig/politics.svg" },
  { title: "Environmental Sustainability", icon: "assets/img/member/sig/local-language.svg" },
  { title: "Pensa", icon: "assets/img/member/sig/local-language.svg" },
  { title: "Safety Valve", icon: "assets/img/member/sig/local-language.svg" },
  ];

  const EmailDisplay = ({ email }) => {
  if (mid) {
    return (
      <a href={`mailto:${email}`} className="chapter-email" style={{fontSize:'12px'}}>
        {email}
      </a>
    );
  }
  return ('');
};

const getImgSrc = (profile_img) => {
  if (!profile_img) return "assets/img/logo/mensatrans2.png";
  // Already a string URL or base64 data URL
  if (typeof profile_img === "string") return profile_img;
  // Buffer object from DB: { type: 'Buffer', data: [...] }
  if (profile_img?.data) {
    const bytes = new Uint8Array(profile_img.data);
    let binary = "";
    bytes.forEach(b => binary += String.fromCharCode(b));
    return `data:image/jpeg;base64,${btoa(binary)}`;
  }
  return "assets/img/logo/mensatrans2.png";
};
// ── Admin Card ─────────────────────────────────────────────────────────────────
const AdminCard = ({ admin, index, isLoggedIn }) => (
  <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 mb-4" data-aos="zoom-in" data-aos-delay={index * 100}>
    <div className="member text-center">
      <div className="pic mx-auto">
        <img
          src={getImgSrc(admin.profile_img)}
          className="img-fluid"
          alt={admin.name || "Admin"}
          style={{ width: "70%", height: "250px", objectFit: "cover", borderRadius: "10%" }}
        />
      </div>
      <div className="member-info mt-2">
        <h5 className="mb-0" style={{fontSize:'15px'}}>{admin.name || "—"}</h5>
        <span className="text-muted small fw-bold">{admin.designation}</span>
        {admin.chapter_name && (
          <div><small className="text-muted">{admin.chapter_name} Chapter</small></div>
        )}
        <div className="mt-1">
          <EmailDisplay email={admin.email} isLoggedIn={isLoggedIn} />
        </div>
      </div>
    </div>
  </div>
);
 
// ── Loading Spinner ────────────────────────────────────────────────────────────
const Spinner = () => (
  <div className="text-center py-4">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

  return (
<div className='bacimage'>
<section className="banner">
  <Slider {...settings}>

    {/* Slide 1 - Clean Image */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Banner 1" />
       <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

    {/* Slide 2 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner3.png" alt="Social Impact" />
      <div className="hero-content">
        <h1 className="hero-title">
          SOCIAL IMPACT
          <br />
          DHRUV &amp; TMNP
        </h1>
       
        <div className="hero-actions">
          <NavLink to="/Spotlight" className="hero-btn hero-btn--primary"> Click Here</NavLink>
        </div>
      </div>
    </div>

    {/* Slide 3 - Text + Button */}
    <div className="hero-slide">
      <img src="assets/img/herobanner.png" alt="Our Mission" />
      <div className="hero-content">
        <h1 className="hero-title">
          THE SOCIETY 
          <br />
          OF HIGH IQ PEOPLE
        </h1>
        <p className="hero-subtitle">
          Mensa is the largest and oldest high IQ society in the
          world. It is a non-profit organization open to people who
          score at the 98th percentile or higher on a standardised,
          supervised IQ or other approved intelligence test.
        </p>
       <p className="hero-title" style={{margin:'0'}}>{Member_count}</p>
      </div>
    </div>

  </Slider>
</section>


    <div className="event" style={{marginTop:'20px'}}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="wow fadeInDown animated" data-animation="fadeInDown animated" data-delay=".2s"
               style={{ visibility: 'visible', animationName: 'fadeInDown' }}>

            <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
              <a className="nav-item nav-link active show" id="nav-home-tab" data-toggle="tab" href="#one" role="tab"
                 aria-selected="true">
                <div className="nav-content">
                  <strong>Chapter</strong>
                 
                </div>
              </a>
              <a className="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#two" role="tab"
                 aria-selected="false">
                <div className="nav-content">
                  <strong>SIG</strong>
                 
                </div>
              </a>
              
            </div>

          </nav>
          </div>
          </div>

          <div className="row">
          <div className="col-lg-12 col-md-12">
          <div className="tab-content wow fadeInDown animated"
      data-animation="fadeInDown animated" data-delay=".2s" id="nav-tabContent"
      style={{ visibility: 'visible', animationName: 'fadeInDown' }}>
      <div className="tab-pane fade active show" id="one" role="tabpanel" aria-labelledby="nav-home-tab">

  {/* ── Admins ── */}
      <section id="admins" className="team section-bg" style={{ marginTop: '40px', paddingBottom: '40px' }}>
        <div className="container" data-aos="fade-up">
          <div className="section-title mb-5">
            <h2>Office Bearers &amp; Chapter Presidents</h2>
          </div>
          {loading ? <Spinner /> : (
            <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 justify-content-center">
              {admins.length === 0
                ? <p className="text-center text-muted">No admins found.</p>
                : admins.map((admin, i) => (
                    <AdminCard key={admin.admin_id ?? i} admin={admin} index={i} isLoggedIn={isLoggedIn} />
                  ))
              }
            </div>
          )}

        </div>
      </section>

      </div>

      <div className="tab-pane fade" id="two" role="tabpanel" aria-labelledby="nav-profile-tab">

      <div className='container'>
        <div className='row'>
          <p>A Special Interest Group (SIG) is a group where specific interests are nurtured and developed. Some chapters have specific SIGs while other chapters may decide to incorporate a rotational system of varying interests to enhance all members’ development. A few SIGs are pan India too.</p>
          <br/>
          <p>Some of the SIGs that exist in India include:</p>
          <hr></hr>
          <center><h2><b>National SIGs</b></h2></center>
          <br></br>
          {items.map((item, index) => (
            <div key={index} className='col-lg-3 col-md-4 col-sm-6 mb-4'>
              <div className="card h-100 shadow-sm border-0 hover-card">
                <div className="card-body text-center d-flex flex-column align-items-center justify-content-center p-4">
                  <div className="icon-wrapper mb-3">
                    <div className="icon-circle">
                      <svg width="60px" height="60px" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                        <image 
                          href={item.icon}
                          width="60" 
                          height="60" 
                        />
                      </svg>
                    </div>
                  </div>
                  <h5 className="card-title mb-0">{item.title}</h5>
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
      <hr></hr>
      <div className='container' style={{marginTop:'20px', marginBottom:'50px'}}>
        <div className='row'>
          <center><h2><b>Regional SIGs</b></h2></center>
            <br></br>

            {regional.map((regional, index) => (
            <div key={index} className='col-lg-3 col-md-4 col-sm-6 mb-4'>
              <div className="card h-100 shadow-sm border-0 hover-card">
                <div className="card-body text-center d-flex flex-column align-items-center justify-content-center p-4">
                  <div className="icon-wrapper mb-3">
                    <div className="icon-circle">
                      <svg width="60px" height="60px" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                        <image 
                          href={regional.icon}
                          width="60" 
                          height="60" 
                        />
                      </svg>
                    </div>
                  </div>
                  <h5 className="card-title mb-0">{regional.title}</h5>
                </div>
              </div>
            </div>
          ))}

          
        
        </div>
      </div>
    </div>
    </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  );
};

  

 


export default Chapter;
